import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map, Observable, of } from 'rxjs';
import { AuthLoginService } from 'src/app/page/auth-page/service/auth-login.service';
import { CronService } from 'src/app/services/cron/cron.service';
import { ProfileService } from 'src/app/services/profile/profile.service';
import { basicDTOInterface } from 'src/app/util/interfaces/basicDTO';
import { checklistInterface } from 'src/app/util/interfaces/checklist';
import { genericFormI } from 'src/app/util/interfaces/genericFormRMK';
import { environment } from 'src/environments/environment';

@Injectable({
	providedIn: 'root',
})
export class ChecklistRegisterPageService {
	private checklistUrl = environment.baseApiUrl + 'checklist';
	private getChecklistDataUrl = environment.baseApiUrl + 'checklist/{idChecklist}';
	private getChecklistGeneralFormUrl = environment.baseApiUrl + 'checklist/form/general';
	private getChecklistProcedureFormUrl = environment.baseApiUrl + 'checklist/form/procedure';

	private headers = new HttpHeaders({
		Authorization: 'Bearer ' + this.AuthLoginService.getSessionToken(),
		'Content-Type': 'application/json;charset=UTF-8',
	});

	constructor(
		private http: HttpClient,
		private AuthLoginService: AuthLoginService,
		private CronService: CronService,
		private ProfileService: ProfileService
	) {}

	getChecklistGeneralForm(): Observable<genericFormI[]> {
		return this.http.get<genericFormI[]>(this.getChecklistGeneralFormUrl, { headers: this.headers });
	}

	getChecklistProcedureForm(): Observable<genericFormI[]> {
		return this.http.get<genericFormI[]>(this.getChecklistProcedureFormUrl, { headers: this.headers });
	}

	createChecklist(checklistData: checklistInterface): Observable<basicDTOInterface> {
		//Converting the cron expression to it's version in UTC;
		checklistData.periodicity = this.CronService.convertCronExpression(
			checklistData.periodicity,
			Intl.DateTimeFormat().resolvedOptions().timeZone,
			'UTC'
		);
		return this.http.post<basicDTOInterface>(this.checklistUrl, checklistData, { headers: this.headers });
	}

	updateChecklist(checklistData: checklistInterface): Observable<basicDTOInterface> {
		const getChecklistUrl = this.getChecklistDataUrl.replace('{idChecklist}', checklistData.id);
		//Converting the cron expression to it's version in UTC;
		checklistData.periodicity = this.CronService.convertCronExpression(
			checklistData.periodicity,
			Intl.DateTimeFormat().resolvedOptions().timeZone,
			'UTC'
		);
		return this.http.put<basicDTOInterface>(getChecklistUrl, checklistData, { headers: this.headers });
	}

	deleteChecklist(idChecklist: string): Observable<basicDTOInterface> {
		const getChecklistUrl = this.getChecklistDataUrl.replace('{idChecklist}', idChecklist);
		return this.http.delete<basicDTOInterface>(getChecklistUrl, { headers: this.headers });
	}

	getChecklistData(idChecklist: string): Observable<checklistInterface> {
		if (idChecklist == '' || idChecklist == undefined) return of();
		const getChecklistUrl = this.getChecklistDataUrl.replace('{idChecklist}', idChecklist);
		return this.http.get<checklistInterface>(getChecklistUrl, { headers: this.headers }).pipe(
			map((checklistRes) => {
				//Converting the cron UTC expression to user GMT;
				checklistRes.periodicity = this.CronService.convertCronExpression(
					checklistRes.periodicity,
					'UTC',
					Intl.DateTimeFormat().resolvedOptions().timeZone
				);
				return checklistRes;
			})
		);
	}
}
